import { useState, useEffect, useContext } from 'react';
import { Alert } from 'reactstrap';
import { RxCrossCircled } from 'react-icons/rx';
import { getDashColor } from '~/shared/components/icons';
import { Link } from 'react-router-dom';
import { CampaignContext } from '~/context/campaign';

const FUND_REQUESTS_DISMISSAL_KEY = 'hhl_fund_requests_announcement_dismissed';

export const FundRequestsAnnouncementCard = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [{ campaign }] = useContext(CampaignContext);

    useEffect(() => {
        // Only show for Funded or Disbursable campaigns
        const campaignStatus = campaign?.campaignDetail?.campaign_status;
        const isEligibleStatus = campaignStatus === 'Disbursable';
        
        // Check if user has already dismissed this announcement
        const hasBeenDismissed = localStorage.getItem(FUND_REQUESTS_DISMISSAL_KEY);
        
        setIsVisible(isEligibleStatus && !hasBeenDismissed);
    }, [campaign]);

    const onDismiss = () => {
        // Save dismissal state to localStorage
        localStorage.setItem(FUND_REQUESTS_DISMISSAL_KEY, 'true');
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <Alert
            style={{
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
                backgroundColor: getDashColor('message'),
                borderColor: getDashColor('message'),
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.25)',
                color: 'white',
                position: 'relative',
            }}
        >
            <RxCrossCircled
                onClick={onDismiss}
                style={{
                    position: 'absolute',
                    top: '30px',
                    right: '25px',
                    fontSize: '1.5rem',
                    color: 'white',
                    cursor: 'pointer',
                }}
                title="Dismiss announcement"
            />
            <div
                className="eyebrow"
                style={{
                    marginBottom: '18px',
                    color: 'white',
                }}
            >
                NEW: Submit Fund Requests Online!
            </div>
            <p>
                Tap Requests from your Dashboard to get started. Need help?{' '}
                <a
                    href="https://helphopelive.org/how-to-submit-a-fund-request/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                        color: 'white', 
                        textDecoration: 'underline',
                        fontWeight: 'bold'
                    }}
                >
                    View our complete guide
                </a>
                .
            </p>
        </Alert>
    );
};